/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.20.0
 */

import { API_SUBSCRIBER_TABLE_LIST } from '@pages/PageSubscriberMobile';

export const TABLE_WIDTH_MAX = 440;
export const TABLE_WIDTH_MIN = 120;

/*
 * список таблиц получающих данные из Elastic Search
 */
export const TableES = {
    subscribers: API_SUBSCRIBER_TABLE_LIST,
};
